import { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { LOADING, LOADED, FAILED } from 'constants/data';

import { getIsDbetLoaded, getDbetData } from 'store/selectors';

const useSDKEffect = ({ method = '', args = [], deps = [] }) => {
  const [value, setValue] = useState();
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(LOADING);
  const isDbetLoaded = useSelector(getIsDbetLoaded);
  const dbetData = useSelector(getDbetData, shallowEqual);

  useEffect(() => {
    let isCanceled = false;

    if (isDbetLoaded) {
      const execute = async () => {
        setError(null);
        setStatus(LOADING);

        try {
          const paramsArray =
            typeof args[args.length - 1] === 'function' ? args.slice(0, -1) : args;
          const response = await dbetData[method](...paramsArray);

          if (isCanceled) return;

          setValue(response);
          setStatus(LOADED);
        } catch (error) {
          if (isCanceled) return;

          setError(error);
          setStatus(FAILED);
        }
      };

      execute();
    }

    return () => {
      isCanceled = true;
    };
  }, deps.concat([...args, method, dbetData, isDbetLoaded])); // eslint-disable-line react-hooks/exhaustive-deps

  return [value, status, error];
};

export default useSDKEffect;
